import { Alert, Button, Container, Grid } from "@mui/material"
import Box from "@mui/material/Box"
import { getAnalytics, logEvent } from "firebase/analytics"
import { FunctionComponent, useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { useLocation } from "react-router-dom"
import { Locale } from "../App"
import AppStore from "../assets/app-store-badge.png"
import GooglePlay from "../assets/google-play-badge.png"
import AppIconBn from "../assets/icon_bn.png"
import AppIconEn from "../assets/icon_en.webp"
import Shot1 from "../assets/shot_1.png"
import Shot1En from "../assets/shot_1_en.webp"
import Shot2 from "../assets/shot_2.png"
import Shot2En from "../assets/shot_2_en.webp"
import Shot3 from "../assets/shot_3.webp"
import Color from "../Color"
import Dimen from "../Dimen"
import Pricing from "./Pricing"
import Reviews from "./Reviews"

export const urlGooglePlay: string =
  "https://play.google.com/store/apps/details?id=org.eyeslave.bangla.taka.converter.activity"

export const urlAppStore =
  "https://apps.apple.com/us/app/bangla-bookkeeper/id1450671613"

// const urlFbFanPage = "https://www.facebook.com/banglabookkeeper"

const mailToBookkeeper =
  "mailto:android.developer@eyeslave.com?Subject=Bookkeeper%20Website"

const callToBK = "tel:+8801323867719"
const HomePage: FunctionComponent<{ locale: Locale; signIn: () => void }> = ({
  locale,
  signIn,
}) => {
  const analytics = getAnalytics()
  const [drawerState, setDrawerState] = useState(false)
  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)

  useEffect(() => {
    toggleDrawer(drawerState)
  })

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return
      }

      setDrawerState(open)
    }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Learn more about bKash payment banner */}
      <Alert
        variant="filled"
        severity="info"
        style={{ background: Color.BKash }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              logEvent(analytics, "web_bkash_learn_more")
              window.scrollTo(0, document.body.scrollHeight)
            }}
          >
            <FormattedMessage id="homepage.banner.bkash.learn.more"></FormattedMessage>
          </Button>
        }
      >
        <FormattedMessage id="homepage.banner.bkash"></FormattedMessage>
      </Alert>
      {/* App Icon and Heading */}
      <Grid container paddingTop={8} paddingLeft={6} paddingRight={8}>
        {/* App Icon */}
        <Grid size={{ md: 5, lg: 5 }}>
          {locale === Locale.Bengali && (
            <img src={AppIconBn} alt="App Icon BN" height={300} />
          )}
          {locale === Locale.English && (
            <img src={AppIconEn} alt="App Icon EN" height={300} />
          )}
        </Grid>

        {/* App Heading */}
        <Grid size={{ md: 7, lg: 7 }}>
          <Grid container justifyContent={"center"}>
            <Grid>
              <div
                style={{ fontSize: Dimen.FontSizeHeading, color: Color.Black }}
              >
                <FormattedMessage id="homepage.title" />
              </div>
            </Grid>

            <Grid>
              <a href={urlGooglePlay} target="_blank">
                <img
                  alt="এন্ড্রোয়েড ভার্সন"
                  src={GooglePlay}
                  width="323"
                  height="125"
                />
              </a>
            </Grid>

            <Grid>
              <a href={urlAppStore} target="_blank">
                <img
                  alt="এপেল ভার্সন"
                  src={AppStore}
                  width="323"
                  height="125"
                />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* First description section */}
      <Grid
        container
        paddingTop={8}
        paddingLeft={8}
        paddingRight={8}
        justifyContent={"center"}
      >
        <Grid size={{ md: 6, lg: 6 }}>
          {locale === Locale.Bengali && <img src={Shot1} alt="Shot_1" />}
          {locale === Locale.English && (
            <img src={Shot1En} width={300} alt="Shot_1" />
          )}
        </Grid>
        <Grid size={{ md: 6, lg: 6 }}>
          <div>
            <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
              <FormattedMessage id="homepage.subsection.one.title" />
            </div>
            <ul style={{ listStyleType: "disc", fontSize: "20px" }}>
              <li>
                <FormattedMessage id="homepage.subsection.one.bulletpoint.one" />
              </li>
              <li>
                <FormattedMessage id="homepage.subsection.one.bulletpoint.two" />
              </li>
              <li>
                <FormattedMessage id="homepage.subsection.one.bulletpoint.three" />
              </li>
              <li>
                <FormattedMessage id="homepage.subsection.one.bulletpoint.four" />
              </li>
            </ul>
          </div>
        </Grid>
      </Grid>

      {/* Second description section */}
      <Grid
        container
        paddingTop={8}
        paddingLeft={8}
        paddingRight={8}
        justifyContent={"center"}
      >
        <Grid size={{ md: 6, lg: 6 }}>
          {locale === Locale.Bengali && <img src={Shot2} alt="Shot_2" />}
          {locale === Locale.English && (
            <img src={Shot2En} width={300} alt="Shot_2" />
          )}
        </Grid>
        <Grid size={{ md: 6, lg: 6 }}>
          <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
            <FormattedMessage id="homepage.subsection.two.title" />
          </div>
          <ul style={{ listStyleType: "disc", fontSize: "20px" }}>
            <li>
              <FormattedMessage id="homepage.subsection.two.bulletpoint.one" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.two.bulletpoint.two" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.two.bulletpoint.three" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.two.bulletpoint.four" />
            </li>
          </ul>
        </Grid>
      </Grid>

      {/* Third description section */}
      <Grid
        container
        paddingTop={8}
        paddingLeft={8}
        paddingRight={8}
        justifyContent={"center"}
      >
        <Grid size={{ md: 6, lg: 6 }}>
          {locale === Locale.Bengali && (
            <img src={Shot3} width={318} alt="Shot_3" />
          )}
          {locale === Locale.English && (
            <img src={Shot3} width={300} alt="Shot_3" />
          )}
        </Grid>
        <Grid size={{ md: 6, lg: 6 }}>
          <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
            <FormattedMessage id="homepage.subsection.three.title" />
          </div>
          <ul style={{ listStyleType: "disc", fontSize: "20px" }}>
            <li>
              <FormattedMessage id="homepage.subsection.three.bulletpoint.one" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.three.bulletpoint.two" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.three.bulletpoint.three" />
            </li>
            <li>
              <FormattedMessage id="homepage.subsection.three.bulletpoint.four" />
            </li>
          </ul>
        </Grid>
      </Grid>

      {/* Reviews */}
      <Reviews />

      {/* Pricing */}
      <Pricing
        email={
          queryParameters.get("email") == null
            ? ""
            : queryParameters.get("email")!!
        }
      />
      <Container
        maxWidth="md"
        component="footer"
        sx={{
          borderTop: (theme) => `2px solid ${Color.Primary}`,
          mt: 8,
          py: [3, 6],
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p>
          <FormattedMessage id="homepage.footer.address" />
        </p>
        <p>
          <a href={callToBK}>
            <FormattedMessage id="homepage.footer.phone" />
          </a>
        </p>
        <p>
          <a href={mailToBookkeeper}>
            <FormattedMessage id="homepage.footer.email" />
          </a>
        </p>
        <p>
          <FormattedMessage id="homepage.footer.warning" />
        </p>
      </Container>
    </Box>
  )
}

export default HomePage
